import {
  routeAuthCodeMap as RouteAuthCodeMap,
  tagAuthCodeMap as TagAuthCodeMap,
  shareMediaMap as ShareMediaMap
} from 'utils/constants';
import { isHasRouteAuth, isHasTagAuth, getAuthRouteList } from 'utils/authUtil';
import Stores from 'config/Stores';
import { Toast, Modal, Picker, ListView } from 'antd-mobile';
import { BannerCell } from 'pubBiz/CommonCell';
import Request from 'utils/request';
import { Carousel } from 'antd-mobile';
import { AddCart } from '@/components/AddCart';
import CommonMiniModal from '@/components/CommonMiniModal';
import Util from 'utils';
import xss from 'xss';
import Config from 'config/Config';
import { NoticeBar } from 'widget';
import CornerMarker from 'pubBiz/CornerMarker';

// import PromotePosterModal from '../pages/shop/Product/ProductDetail/PromoteModal/PromoteModalView';
//云店店铺状态
const YunDianStatus = {
  INACTIVATED: 1, // 未激活
  EFFECT: 2, // 有效
  UN_EFFECT: 3, // 禁用
  UN_AUDIT: 4, // 待审核
  EXPIRED: 5, // 已过期
  CANCEL: 6, // 已取消
  UN: 7 // 待定
};
// 导出变量给跨端使用
global.isHasRouteAuth = isHasRouteAuth;
global.isHasTagAuth = isHasTagAuth;
global.getAuthRouteList = getAuthRouteList;
global.YunDianStatus = YunDianStatus;
global.ConstantList = { ShareMediaMap, RouteAuthCodeMap, TagAuthCodeMap };
global.toast = Toast;
global.Modal = Modal;
global.getUserInfo = () => Stores.AppMod.getUserInfo();
// 组件
global.BannerCell = BannerCell;
// 埋点
global.SaUtil = {
  ...window.sensors,
  trackEvent: window.sensors.track
};
// 网络请求
global.request = Request;
// global.PromotePosterModal = PromotePosterModal;
// mobx
global.GlobalMobx = {
  ...Stores,
  ...{
    initMobx: Stores.AppMod
  }
};
global.Picker = Picker;
global.Util = Util;
global.xss = xss;
global.Config = Config;
global.CornerMarker = CornerMarker;

window.Carousel = Carousel;
window.AddCart = AddCart;
window.ListView = ListView;
window.CommonMiniModal = CommonMiniModal;
window.NoticeBar = NoticeBar;



// WEBPACK FOOTER //
// ./src/function/globalApi.js